<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading">
      {{ $t("loadingTxt") }}...
    </div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
      <!--begin::sidebar-->
      <sidebar-component classMenu="TransportOrder"></sidebar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

        <!--begin::content-->

        <div class="page-content">
          <div class="col-lg-12 col-xl-12 stretch-card">
            <div class="card">



              <div class="card-header">
                <div class="row">
                  <div class="col-lg-3 col-md-6">
                    <h4 class="float-start">Transportation Segment SAP</h4>
                  </div>
 

                  <div class="col-lg-9 col-md-12">
                    <div class="d-flex flex-wrap justify-content-end">
                      <button v-if="permision_role.method_create" class="btn btn-primary btn-xs me-2 mb-2"
                        @click.prevent="createData()">
                        <i class="link-icon" data-feather="plus"></i> {{ $t("createNew") }}
                      </button>
                 
                      <button v-if="permision_role.method_read" class="btn btn-success btn-xs mb-2"
                        @click.prevent="downloadData()">
                        <i class="link-icon" data-feather="download"></i> {{ $t("downloadData") }} .xlsx
                      </button>
                    </div>
                  </div>
                </div>
              </div>




              <div class="card-body">
              
                <vue-good-table title="list-transportation-segment-sap" ref="list-transportation-segment-sap" mode="remote" :select-options="{
                  enabled: false,
                }" @on-page-change="onPageChange" @on-sort-change="onSortChange"
                  @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange" :totalRows="totalRecords"
                  :line-numbers="true" :isLoading.sync="isLoading" :pagination-options="{
                    enabled: true,
                  }" :rows="rows" :columns="columns">
                  

 

                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'actions'">

                      <a href="#" v-if="permision_role.method_update" title="Edit" @click.prevent="editData(props.index, props.row)">
                        <i class="mdi mdi-square-edit-outline" style="font-size: 16px;color:goldenrod;"></i>
                      </a>

                      <a href="#" v-if="permision_role.method_update && props.row.active == 'ACTIVE'" title="InActive" @click.prevent="updateData(props.index, props.row,'INACTIVE')">
                        <i class="mdi mdi-power" style="font-size: 16px;color:red;"></i>
                      </a>

                      <a href="#" v-if="permision_role.method_update && props.row.active == 'INACTIVE'" title="Active" @click.prevent="updateData(props.index, props.row,'ACTIVE')">
                        <i class="mdi mdi-power" style="font-size: 16px;color:greenyellow;"></i>
                      </a>

                    </span>
                    
                    <span v-else>
                      {{ props.formattedRow[props.column.field] }}
                    </span>
                  </template>
                </vue-good-table>
              </div>
            </div>
          </div>
        </div>
        <!-- Cancel data-->

        <modal-segment-create :showModal="showModalCreateSegment" :data="null" @closeModal="closeMyModal">  </modal-segment-create>
        <modal-segment-update :showModal="showModalUpdateSegment" :data="this.dataUpdateNya" @closeModal="closeMyModal">  </modal-segment-update>
 
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer"; 

import ModalTransportationSegmentCreate from "@/components/modal/modalTransportationSegmentCreate.vue";
import ModalTransportationSegmentUpdate from "@/components/modal/modalTransportationSegmentUpdate.vue";


export default {
  name: "TransportationSegment",
  components: {

    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    "modal-segment-create": ModalTransportationSegmentCreate,
    "modal-segment-update": ModalTransportationSegmentUpdate,

  },
  data() {
    
    return {

      locale: {
        format: "yyyy-mm-dd",
      },
      passData: [],
      dataUpdateNya:{},
      showModalCreateSegment: false,
      showModalUpdateSegment: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      isLoading: false,
      status_order: "",
      errors: [],
      permision_role: [],
      langs: ["id", "en"],
      detailUser: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 10,
      },
      columns: [
        {
          label: "Action",
          field: "actions",
          sortable: false,
        },

        {
          label: "Status",
          field: "active",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By Status", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Order Group",
          field: "order_group",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By Order Group", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: "Value",
          field: "value",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By Value", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: "Remarks",
          field: "remark",
          filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "Filter By Remarks", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
    
      ],
      rows: [],
      rowsSelection: [],
    };
  },
  watch: {},
  methods: {
     

    closeMyModal() {
      this.showModalCreateSegment = false;
      this.showModalUpdateSegment = false;
      this.loadItems();
    },
   

    createData() {
      this.showModalCreateSegment = true;
    },

     

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (
          permision.permission.controller == "TransportationSegmentController"
        ) {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
    },
 
 
    downloadData() {
      const baseURI = this.$settings.endPoint + "/transportation-segment/index";
      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name = "download_" + CurrentDate + ".xlsx";

      return this.$http
        .get(
          baseURI +
          `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&order_group=${this.serverParams.columnFilters.order_group}&value=${this.serverParams.columnFilters.value}&active=${this.serverParams.columnFilters.active}&download=download`,
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },
  
 
    editData(index, row) {
        this.dataUpdateNya = row;
      this.showModalUpdateSegment = true;
    },
 

    updateData(index, row , status) {

      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataSend"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          this.loading();
          var formData = {
            active: status
          }
          const baseURI = this.$settings.endPoint + "transportation-segment/update-status/" + row.transportation_segment_id;
          this.$http
            .put(baseURI, formData)
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                this.loadItems();
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();
              if (error.response) {
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                  this.resultError(error.response.data.errors);
                } else if (error.response.status === 500) {
                  this.$router.push("/server-error");
                } else {
                  this.$router.push("/page-not-found");
                }
              }
            });
        }
      });

    },

    // load items is what brings back the rows from server
    loadItems() {
      const baseURI = this.$settings.endPoint + "transportation-segment/index";
      //var columnFilters = this.serverParams.columnFilters;
     
      return this.$http
        .get(
          baseURI +
          `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&order_group=${this.serverParams.columnFilters.order_group}&value=${this.serverParams.columnFilters.value}&active=${this.serverParams.columnFilters.active}`,
          { timeout: 10000 }
        )
        .then((response) => {
          this.rows = response.data.datas.data;
          this.totalRecords = response.data.datas.total;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else if (error.response.status === 401) {
                this.$router.push("/authorized-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      this.loadItems();
    },

    onColumnFilter(params) {
      params.page = 1;
      this.updateParams(params);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

    onPerPageChange(params) {
      this.updateParams({ per_page: params.currentPerPage });
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    success2(msg) {
      let pesan = "";
      msg.forEach((item) => {
        pesan = pesan + "<p>* " + item + "</p>";
      });

      this.$swal({
        icon: "info",
        backdrop: true,
        title: "Information",
        html: pesan,
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    },

    loadingSubmiting() {
      this.$swal({
        icon: "warning",
        backdrop: true,
        title: "Please wait",
        html: "<h2>SUBMITTING ORDER...</h2>",
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.isLoading = false;
      }, 5000); // hide the message after 3 seconds
    },

    logout() {
      this.$logoutUser();
      this.$router.push("/");
    },
  },
  events: {},
  created: function () { },
  mounted() {
    this.fetchIt();
    this.loading();
  },
};
</script>
<style scoped>
button.gm-ui-hover-effect {
  visibility: hidden;
}

.blur-content {
  filter: blur(5px);
}

.card-body {
  padding: 5px 1.5rem 1rem;
}

.main-wrapper .page-wrapper .page-content {
  margin-top: 40px;
}

.vgt-table th {
  text-align: left;
}
</style>
